import { render, staticRenderFns } from "./WflowFormDesigner.vue?vue&type=template&id=e5b28998&scoped=true"
import script from "./WflowFormDesigner.vue?vue&type=script&lang=js"
export * from "./WflowFormDesigner.vue?vue&type=script&lang=js"
import style0 from "./WflowFormDesigner.vue?vue&type=style&index=0&id=e5b28998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b28998",
  null
  
)

export default component.exports